<template>
  <v-main id="books">
  <v-container fluid>
    <v-row dense>
      <v-col v-for="book in displayBooks" :key="book.name" :cols="book.flex">
        <v-card>
          <v-card-title v-text="book.name"></v-card-title>
          <v-card-text class="text--primary">
            <div>{{ book.description }}</div>

            <div>
              <a :href="book.link" target="_blank">Завантажити</a>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'LibraryPage',

  data() {
    return {};
  },
  async mounted() {
    await this.$store.dispatch('LibraryStore/loadBooks');
  },
  computed: {
    displayBooks() {
      const books = this.$store.getters['LibraryStore/getBooks'];
      return books.map((book) => {
        book.flex = 3;
        return book;
      });
    },
  },

  methods: {},
};
</script>
